import { StyleSheet, View } from 'react-native';

import { Typography } from 'components/ui';
import { t } from 'state/intl/translations';
import { spacing } from 'styles/constants';

export function FlatCustomizationHeader() {
  return (
    <View>
      <Typography style={styles.header} variant="headerOne">
        {t('haveItYourWay')}
      </Typography>
    </View>
  );
}

const styles = StyleSheet.create({
  header: {
    alignSelf: 'center',
    paddingBottom: spacing.$2,
  },
});
